import React from "react";
import { Megaphone } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const MetaNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={Megaphone}
    subtitle="Paid social presence and engagement signal interpretation"
    badge="META"
    theme={{
      cardBg: "#f5f3ff",
      cardBorder: "#ddd6fe",
      heroBg: "#ede9fe",
      heroBorder: "#c4b5fd",
      badgeBg: "rgba(124, 58, 237, 0.12)",
      badgeBorder: "#7c3aed",
      iconColor: "#6d28d9",
      dotColor: "#8b5cf6",
    }}
  />
);

export default MetaNarrativeAssessmentViewer;
